@if (displayPaging) {
  <div class="row page-row">
    <table class="page-row">
      <tbody>
        <tr>
          <td>
            <button class="link-btn page-btn deadLink" [class.deadLink]="pageIndex === 0" type="button" (click)="previousPage()">
              &lt;&nbsp;{{ 'PAGING.PREVIOUS' | translate }}
            </button>
          </td>
          @for (page of pageSelection; track page) {
            <td>
              <button
                class="link-btn page-btn selected"
                [class.selected]="page.value === pageIndex"
                type="button"
                (click)="pageIndex = page.value"
                >
                {{ page.name }}
              </button>
            </td>
          }
          <td>
            <button class="link-btn page-btn deadLink" [class.deadLink]="pageIndex === lastPageIndex" type="button" (click)="nextPage()">
              {{ 'PAGING.NEXT' | translate }}&nbsp;&gt;
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
@if (displayFirstLast) {
  <div class="row page-row">
    <table class="page-row">
      <tbody>
        <tr>
          <td>
            <button class="link-btn page-btn deadLink" [class.deadLink]="pageIndex === 0" type="button" (click)="pageIndex = 0">
              &lt;&lt;&nbsp;{{ 'PAGING.FIRST' | translate }}
            </button>
          </td>
          <td>
            <button
              class="link-btn page-btn deadLink"
              [class.deadLink]="pageIndex === lastPageIndex"
              type="button"
              (click)="pageIndex = lastPageIndex"
              >
              {{ 'PAGING.LAST' | translate }}&nbsp;&gt;&gt;
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
@if (totalCount > 0) {
  <div class="row page-row">
    <table class="page-row">
      <tbody>
        <tr>
          <td>{{ 'PAGING.PAGE_SIZE' | translate }}:</td>
          @for (size of displayCountSelection; track size) {
            <td>
              <button
                class="link-btn page-btn selected"
                [class.selected]="size.value === displayCount"
                type="button"
                (click)="displayCount = size.value"
                >
                {{ size.name }}
              </button>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
}
